
var upload = {
    options: null,
    dialogEl: null,

    start: function(el, options) {
        upload.options = options || {};
        var params = (el.is('[data-params]')) ? '&' + el.attr('data-params') : '' ;
        if (options.params != null) {
            params += '&'+$.param(options.params);
        }

        var html = ('<div><form class="form" action="'+el.attr('data-upload')+params+'" enctype="multipart/form-data" method="post">' +
            '<div class="form-group">' +
            '<input class="form-control" type="file" name="File" />' +
            '<div class="invalid-feedback"></div>' +
            '</div>' +
            '</form></div>');
        upload.dialogEl = messaging.askContentDialog(el, (el.attr('data-title') || 'Bild hochladen'), html);

        var form = upload.dialogEl.find('form');
        notification.addButton(upload.dialogEl, {
            caption: "Datei hochladen",
            cssClass: "btn btn-success",
            callback: function() {
                form.submit();
                return false;
            }
        });
        form.on('submit', function() {
            $('<div class="progress-loader"><img src="/files/images/progressbar.gif" /></div>').prependTo(form);
            upload.dialogEl.find('.btn-success').prop('disabled', true);
            return true;
        });

        var iframe = $('<iframe border="0" class="d-none" src="about:blank" name="frm-'+ Math.random() +'"></iframe>').appendTo(upload.dialogEl);
        upload.dialogEl.find('form').attr('target', iframe.attr('name'));
    },

    iframeLoaded: function(response) {
        try {
            var data = JSON.parse(response);
            if (data.status == 'ok') {
                notification.close(upload.dialogEl);
                if (upload.options.success) upload.options.success(data);
            } else {
                upload.dialogEl.find('.invalid-feedback').html(data.error);
                if (upload.options.error) upload.options.error(data);
            }
        } catch (e) {
            upload.dialogEl.find('.invalid-feedback').html((response || "Fehler beim upload.").trim());
        }
        upload.dialogEl.find('.progress-loader').remove();
        upload.dialogEl.find('.btn-success').prop('disabled', false);
    },

    iframeLoadedError: function(response) {
        try {
            var data = JSON.parse(response);
            upload.dialogEl.find('.invalid-feedback').html(data.error || "Fehler beim upload.");
            if (upload.options.error) upload.options.error(data.error);
            connection.addFormErrors(upload.dialogEl.find('form'), data);
        } catch (e) {
            upload.dialogEl.find('.invalid-feedback').html((response || "Fehler beim upload.").trim());
        }
        upload.dialogEl.find('.progress-loader').remove();
        upload.dialogEl.find('.btn-success').prop('disabled', false);
    }

};
window.upload = upload;

$(document).ready(function () {
    var $fileUploadEl = $('.file-upload');
    if ($fileUploadEl.length > 0) {
    }
});
